import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import { Main, Login, ResetPassword, ForgetPassword, Files } from './pages';
import { AlertInfos, SplashScreen } from './components';
import { paths } from './routes';
import { State } from './store/reducers';
import 'date-fns';

const createTheme = (darkMode: boolean) =>
  createMuiTheme({
    palette: {
      type: darkMode ? 'dark' : 'light',
      primary: {
        // light: will be calculated from palette.primary.main,
        main: '#19a7d3',
        // dark: will be calculated from palette.primary.main,
        contrastText: '#fff',
      },
      secondary: {
        //light: '#0066ff',
        main: '#ca005d',
        // dark: will be calculated from palette.secondary.main,
        //contrastText: '#ffcc00',
      },
      // Used by `getContrastText()` to maximize the contrast between
      // the background and the text.
      //contrastThreshold: 3,
      // Used by the functions below to shift a color's luminance by approximately
      // two indexes within its tonal palette.
      // E.g., shift from Red 500 to Red 300 or Red 700.
      tonalOffset: 0.2,
    },
    typography: {
      fontFamily: ['gotham', 'Roboto', 'Arial', 'sans-serif'].join(','),
    },
    overrides: {
      MuiButton: {
        root: {
          borderRadius: 50,
          height: 40,
        },
      },
    },
  });

const Root: React.FC = () => {
  const darkMode = useSelector((state: State) => state.settings.darkMode);

  const theme = useMemo(() => createTheme(darkMode), [darkMode]);
 localStorage.setItem('path',window.location.pathname)
  return (
    <ThemeProvider theme={theme}>
      <SplashScreen>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Router>
            <Switch>
              <Route path={paths.login.path}>
                <Login />
              </Route>
              <Route path={paths.resetPassword.path}>
                <ResetPassword />
              </Route>
              <Route path={paths.forgetPassword.path}>
                <ForgetPassword />
              </Route>
              <Route path={paths.fileViewer.path}>
                <Files />
              </Route>
              <Route path="/">
                <Main />
              </Route>
            </Switch>
          </Router>
          <AlertInfos />
        </MuiPickersUtilsProvider>
      </SplashScreen>
    </ThemeProvider>
  );
};

export default Root;
